/* @flow */

import { NOTIFICATION_COMPONENT_KEYS } from 'src/shared/app/notification/constant/notificationComponentsMap';
import {
  notificationInfoLevel,
  notificationModalType,
} from 'src/shared/app/notification/constant/notificationConstants';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import { NEW_TOPICS_MODAL } from 'src/shared/app/topic/new/constant/newTopicConstants';

export const maxTopicTitleLength = 95;

export function convertEngagementTriggerToNotification(
  type: string,
): Notification<> {
  if (
    type === NEW_TOPICS_MODAL.FIRST_LOGIN ||
    type === NEW_TOPICS_MODAL.FIRST_LOGIN_EMPTY_MARKET
  ) {
    return {
      id: 'new-topic-first-login',
      level: notificationInfoLevel,
      type: notificationModalType,
      componentKey: NOTIFICATION_COMPONENT_KEYS.NEW_TOPIC_FIRST_LOGIN,
      data: { type },
    };
  }

  if (type === NEW_TOPICS_MODAL.TOPIC_ENGAGEMENT) {
    return {
      id: 'topic-engagement-ongoing-events',
      level: notificationInfoLevel,
      type: notificationModalType,
      componentKey: NOTIFICATION_COMPONENT_KEYS.TOPIC_ENGAGEMENT_ONGOING_EVENTS,
      data: { type },
    };
  }

  return {
    id: 'new-topic-returning',
    level: notificationInfoLevel,
    type: notificationModalType,
    componentKey: NOTIFICATION_COMPONENT_KEYS.NEW_TOPIC_RETURNING,
    data: { type },
  };
}
